"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.22.1
 */
'use client';

function intersperse(arr, separator) {
  return arr.flatMap((item, idx) => idx < arr.length - 1 ? [item, separator] : [item]);
}

export { intersperse };
